// src/pages/BlogsPage.jsx
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { collection, getDocs, query, where, orderBy } from "../services/mysqlStore";
import { db } from "../services/mysqlStore";
import "./BlogsPage.css";

const PostIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="8" y1="13" x2="16" y2="13" /><line x1="8" y1="17" x2="16" y2="17" />
  </svg>
);

function formatDate(ts) {
  if (!ts?.toDate) return "";
  return ts.toDate().toLocaleDateString("en-CA", { day: "numeric", month: "long", year: "numeric" });
}

export default function BlogsPage() {
  const [blogs, setBlogs]     = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const q = query(
          collection(db, "blogs"),
          where("published", "==", true),
          orderBy("createdAt", "desc")
        );
        const snap = await getDocs(q);
        setBlogs(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <div className="blogs-page">
      <div className="blogs-hero">
        <div className="container reveal">
          <span className="tag">Our Blog</span>
          <h1 className="section-title">Printing Tips &amp; Insights</h1>
          <p className="section-subtitle">Guides, advice, and updates from the Circuit Printing team.</p>
        </div>
      </div>

      <div className="container" style={{ padding: "48px 20px 80px" }}>
        {loading ? (
          <div className="blogs-grid">
            {[1, 2, 3].map(i => <div key={i} className="blog-skeleton shimmer" />)}
          </div>
        ) : blogs.length === 0 ? (
          <div className="blogs-empty reveal">
            <PostIcon />
            <p>No blog posts yet. Check back soon!</p>
          </div>
        ) : (
          <div className="blogs-grid">
            {blogs.map((b, i) => (
              <Link to={`/blogs/${b.slug}`} key={b.id} className={`blog-card reveal delay-${(i % 6) + 1}`}>
                <div className="blog-card-img">
                  {b.coverImageUrl
                    ? <img src={b.coverImageUrl} alt={b.title} />
                    : <div className="blog-card-img-placeholder"><PostIcon /></div>
                  }
                </div>
                <div className="blog-card-body">
                  <span className="blog-card-date">{formatDate(b.createdAt)}</span>
                  <h3>{b.title}</h3>
                  {b.excerpt && <p className="blog-card-excerpt">{b.excerpt}</p>}
                  <span className="blog-card-readmore">Read More →</span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
